import { Link } from "react-router-dom";

export function Logo({ dark = false, className = "" }) {
  return (
    <Link to="/" data-testid="site-logo" className={`flex items-center gap-2 ${className}`}>
      <span className={`grid h-10 w-10 place-items-center overflow-hidden rounded-lg ${dark ? "bg-white" : ""}`}>
        <img src="/images/logo-mark.png" width="40" height="40" alt="Jobfixnow logo" className="h-10 w-10 object-contain" />
      </span>
      <span className={`text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-[#0B1B2B]"}`}>
        Job<span className="text-[#00B94F]">fix</span>now
      </span>
    </Link>
  );
}
